export class DropboxRevokeTokenRequest{
    public requestorId!:number;
    public customerId!:number;
    public clientId!:number;
}